import {
  COUNSELOR,
  ACCOUNTANT,
  BRANCH_ADMIN,
  FACULTY,
  FRONT_OFFICE,
  PARENT,
  STAFF,
  STUDENT,
  SUPER_ADMIN,
} from './types';

export const COUNSELOR_DUMMY_ROLE_ID = -999001;

export const normalizeRoleName = (role?: string) => {
  return String(role || '').toLowerCase().replace(/[^a-z]/g, '');
};

export const isStaff = (role: string) => {
  return role === STAFF;
};

export const isParent = (role: string) => {
  return role === PARENT;
};

export const isStudent = (role: string) => {
  return role === STUDENT;
};

export const isSuperAdmin = (role: string) => {
  return role === SUPER_ADMIN;
};

export const isBranchAdmin = (role: string) => {
  return role === BRANCH_ADMIN;
};

export const isAccountant = (role: string) => {
  return role === ACCOUNTANT;
};

export const isFrontOffice = (role: string) => {
  return role === FRONT_OFFICE;
};

export const isFaculty = (role: string) => {
  return role === FACULTY;
};

export const isCounselorStaffRole = (role?: string) => {
  return normalizeRoleName(role) === normalizeRoleName(COUNSELOR);
};

export const isDummyCounselorStaffRole = (role?: { STAFF_ROLE_ID?: number; STAFF_ROLE_NAME?: string }) => {
  return Number(role?.STAFF_ROLE_ID) === COUNSELOR_DUMMY_ROLE_ID &&
    isCounselorStaffRole(role?.STAFF_ROLE_NAME);
};

export const shouldShowDummyCounselorRole = () => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  return ['localhost', '127.0.0.1'].includes(hostname);
};

export const getDummyCounselorRole = (staffId = 1) => ({
  STAFF_ID: staffId || 1,
  STAFF_ROLE_ID: COUNSELOR_DUMMY_ROLE_ID,
  BRANCH_ROLE_ID: COUNSELOR_DUMMY_ROLE_ID,
  STAFF_ROLE_NAME: 'COUNSELOR',
});

export const appendDummyCounselorRole = <T extends { STAFF_ID?: number; STAFF_ROLE_ID?: number; STAFF_ROLE_NAME?: string }>(
  roles: T[] = [],
) => {
  if (!shouldShowDummyCounselorRole()) {
    return roles;
  }

  const hasCounselorRole = roles.some(role => isCounselorStaffRole(role?.STAFF_ROLE_NAME));
  if (hasCounselorRole) {
    return roles;
  }

  return [
    ...roles,
    getDummyCounselorRole(roles?.[0]?.STAFF_ID),
  ] as T[];
};
